module.exports = __webpack_public_path__ + "static/media/quantum.7b6882c1.png";